import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { SortDirectionDto } from '@/api/generated';
import { CustomTableStateModel } from '@/components/table/model/CustomTableState.model.ts';

export interface CustomTableContextProps<
  SORT_BY_COLUMN_NAME_MODEL extends string,
  SEARCH_FORM_MODEL extends object,
  ROW_ITEM_MODEL extends object,
> {
  customTableState: CustomTableStateModel<
    SORT_BY_COLUMN_NAME_MODEL,
    SEARCH_FORM_MODEL,
    ROW_ITEM_MODEL
  >;
  setCustomTableState: Dispatch<
    SetStateAction<
      CustomTableStateModel<SORT_BY_COLUMN_NAME_MODEL, SEARCH_FORM_MODEL, ROW_ITEM_MODEL>
    >
  >;
}

export const customTableContextDefaultValues: CustomTableContextProps<string, object, object> = {
  customTableState: {
    data: {
      items: [],
      totalPages: 0,
      totalResults: 0,
    },
    page: 0,
    pageSize: 10,
    params: {},
    sortBy: '',
    sortOrder: SortDirectionDto.Asc,
  },
  setCustomTableState: () => {},
};

export const CustomTableContext = createContext(customTableContextDefaultValues);

export const useCustomTableContext = <
  SORT_BY_COLUMN_NAME_MODEL extends string,
  SEARCH_FORM_MODEL extends object,
  ROW_ITEM_MODEL extends object,
>(): CustomTableContextProps<SORT_BY_COLUMN_NAME_MODEL, SEARCH_FORM_MODEL, ROW_ITEM_MODEL> => {
  return useContext(CustomTableContext) as unknown as CustomTableContextProps<
    SORT_BY_COLUMN_NAME_MODEL,
    SEARCH_FORM_MODEL,
    ROW_ITEM_MODEL
  >;
};
